import React, { Component } from 'react';
import { Switch, Image, Animated, TouchableHighlight, LayoutAnimation, Platform, Picker as rnPicker, StyleSheet, Dimensions, TouchableOpacity, FlatList } from 'react-native';
import Slider from '../components/slider';
import Modal from '../components/modal';
//... 31st March, someone wrote this for web. Just waiting for this to be merged!  https://github.com/react-native-community/react-native-slider/pull/165

import { Text, Icon, IconNB, Input, List, ListItem, InputGroup, TextInput, CheckBox, Item, Label, Left, View, Right, Button, Picker as nbPicker, Body } from 'native-base';
import DatePicker from '../components/rn-datepicker';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import { InteractionManager } from 'react-native-web';

const Picker = Platform.OS == 'ios' ? nbPicker : rnPicker;

function minusOf(val, currency) {
	val = Math.abs(val);
	if (currency) return (0 - Number(val)).toFixed(2);
	return (0 - Number(val)).toString();
}
const isWeb = Platform.OS == 'web';

const redColour = '#933';
const greenColour = '#367336';
const darkGrey = '#777';

class textInput extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			showPass: false
		};
	}

	render() {
		const {
			input: { onChange, onBlur, value, ...restInput },
			label,
			returnKeyType,
			style,
			textAlign = 'left',
			postScript,
			multiline = false,
			selectTextOnFocus,
			disabled = false,
			secureTextEntry = false,
			allowInsecure = true,
			uCase = false,
			onEnter,
			keyboardType = 'default',
			placeholder,
			icon,
			labelType = 'inline',
			labelWidth = '25%',
			inputWidth = '100%',
			labelPress,
			refField,
			type,
			maxLength,
			numberOfLines = 1,
			autoFocus,
			labelFlex,
			meta: { touched, error, invalid, warning },
			custom,
			children
		} = this.props;

		return (
			<View style={[styles.mainContainer, style]}>
				<View style={styles.innerContainer}>
					{icon && <Icon name={icon} style={styles.icon} />}
					{label && labelType == 'inline' && <Label style={[styles.inlineLabel, { width: labelWidth }]}>{label}</Label>}
					{labelPress && (
						<TouchableOpacity style={{ width: 10, marginRight: 10 }} onPress={labelPress}>
							<Icon name="help-circle" style={styles.helpCircle} />
						</TouchableOpacity>
					)}
					<View style={{ flex: 1 }}>
						<Item
							accessible={false}
							floatingLabel={labelType == 'floating'}
							stackedLabel={labelType == 'stacked'}
							fixed={labelType == 'fixed'}
							style={{ flex: 1 }}
							error={touched && !!error}
							success={touched && !error && !invalid}>
							{!!label && labelType != 'inline' && <Label style={styles.label}>{label}</Label>}
							<View style={labelType == 'stacked' ? { flexDirection: 'row', width: '100%' } : styles.innerContainer}>
								<Input
									ref="input"
									placeholder={placeholder}
									returnKeyType={returnKeyType}
									style={{ paddingRight: 9, minWidth: 0, textAlign, width: '100%' }}
									secureTextEntry={Platform.OS == 'android' ? secureTextEntry || uCase : secureTextEntry && !this.state.showPass}
									multiline={multiline}
									autoFocus={autoFocus}
									numberOfLines={numberOfLines}
									selectTextOnFocus={selectTextOnFocus}
									keyboardType={Platform.OS == 'android' && (uCase || this.state.showPass) ? 'visible-password' : keyboardType}
									disabled={disabled}
									maxLength={maxLength}
									autoCapitalize={uCase ? 'characters' : null}
									ref="input"
									value={value}
									onChangeText={uCase ? v => onChange(v.toUpperCase()) : onChange}
									onEndEditing={onBlur}
									onBlur={isWeb ? onBlur : undefined}
									placeholderTextColor="#AAA"
									{...restInput}
									onSubmitEditing={onEnter}
								/>
								{!!secureTextEntry && allowInsecure && (
									<TouchableHighlight
										style={{ marginRight: touched && (error || (!!value && !error)) ? 15 : 7 }}
										underlayColor="#EEE"
										onPress={() => this.setState({ showPass: !this.state.showPass })}>
										<Icon name={this.state.showPass ? 'eye-off' : 'eye'} style={{ color: '#888' }} />
									</TouchableHighlight>
								)}
								{touched && !!value && !error && <Icon name="checkmark-circle" style={styles.checkMark} />}
								{touched && error && <Icon name="close-circle" style={styles.errorMark} />}
							</View>
						</Item>
						{touched && error && <Text style={{ color: redColour }}>{error}</Text>}
					</View>
				</View>
				{children}
			</View>
		);
	}
}

const displayInput = ({ input: { onChange, ...restInput }, style = {}, meta: { touched, error, invalid, warning }, note = false, pre = '', currency = false, minus = false }) => {
	return (
		<>
			<Text style={[style, error && { borderColor: '#F00', borderWidth: 1 }]} note={note}>
				{pre}
				{minus ? minusOf(restInput.value, currency) : restInput.value}
			</Text>
			{touched && error && <Text style={{ color: 'red' }}>{error}</Text>}
		</>
	);
};

class picInput extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			big: false,
			bigness: new Animated.Value(0)
		};
	}

	_setAnimation(enable) {
		//LayoutAnimation.configureNext(LayoutAnimation.Presets.spring);
		this.setState({ big: enable });
		Animated.timing(this.state.bigness, {
			duration: 300,
			toValue: enable ? 1 : 0,
			useNativeDriver: true
		}).start();
	}

	render() {
		const {
			input: { onChange, value, ...restInput },
			onAdd
		} = this.props;

		const scale = this.state.bigness.interpolate({
			inputRange: [0, 1],
			outputRange: [0.3, 1],
			extrapolate: 'clamp'
		});

		const width = this.state.bigness.interpolate({
			inputRange: [0, 1],
			outputRange: [80, 300],
			extrapolate: 'clamp'
		});
		const rotateX = this.state.bigness.interpolate({
			inputRange: [0, 1],
			outputRange: ['10deg', '0deg'],
			extrapolate: 'clamp'
		});
		//base64 as value, render image or +
		return value ? (
			<View>
				<Modal
					onClosed={() => this._setAnimation(false)}
					style={{ alignItems: 'center', justifyContent: 'center', width: '100%', backgroundColor: 'rgba(0,0,0,0)' }}
					backButtonClose
					coverScreen
					swipeThreshold={100}
					onRequestClose={() => this._setAnimation(false)}
					animationType="fade"
					isOpen={this.state.big}>
					<View style={{ flex: 1, width: '100%', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(0,0,0,0.5)' }}>
						<Animated.Image style={{ margin: 20, flex: 1, width: '100%', resizeMode: 'contain', transform: [{ scale }] }} source={{ uri: 'data:image/jpg;base64,' + value }} />
						<Button style={{ position: 'absolute', top: 35, right: 25, padding: 10 }} onPress={() => this._setAnimation(false)}>
							<FontAwesome name="close" style={{ fontSize: 24, color: 'white' }} />
						</Button>
					</View>
				</Modal>
				<TouchableOpacity style={{ flex: 1 }} onPress={() => this._setAnimation(true)}>
					<Image style={{ height: 80, width: 80, resizeMode: 'contain', transform: [{ rotateZ: '10deg' }] }} source={{ uri: 'data:image/jpg;base64,' + value }} />
				</TouchableOpacity>
				<TouchableOpacity style={{ position: 'absolute', top: 4, right: 2 }} onPress={() => onChange(null)}>
					<FontAwesome name="trash" style={{ color: 'red', fontSize: 24 }} />
				</TouchableOpacity>
			</View>
		) : (
			<Button bordered onPress={onAdd}>
				<Icon name="camera" style={{ alignSelf: 'center', width: 22 }} />
			</Button>
		);
	}
}

class percentInput extends React.PureComponent {
	render() {
		const {
			input: { onChange, onBlur, ...restInput },
			label,
			style,
			labelType = 'inline',
			disabled = false,
			icon,
			type,
			meta: { touched, error, invalid, warning }
		} = this.props;
		const width = labelType == 'floating' ? undefined : '50%';

		return (
			<View style={[style, { flexDirection: 'row', width: '100%', alignItems: 'center' }]}>
				{!!icon && <Icon name={icon} style={styles.icon} />}
				{label && labelType == 'inline' && <Label style={[styles.inlineLabel, { width }]}>{label}</Label>}
				<Item
					accessible={false}
					style={{ flex: 1 }}
					floatingLabel={labelType == 'floating'}
					inlineLabel={labelType == 'inline'}
					stackedLabel={labelType == 'stacked'}
					error={!!error}
					success={touched && !error && !invalid}>
					{labelType != 'inline' && label ? <Label style={{ width, flexDirection: 'row', color: '#2f6483' }}>{label}</Label> : undefined}
					<Input ref="input" selectTextOnFocus keyboardType={'numeric'} disabled={disabled} style={{ minWidth: 0, textAlign: 'right' }} onChangeText={onChange} onEndEditing={onBlur} {...restInput} />

					<Text style={{ marginRight: 30 }}>%</Text>
					{touched && !!restInput.value && !error && <Icon name="checkmark-circle" style={styles.checkMark} />}
					{error && <Icon name="close-circle" style={styles.errorMark} />}
				</Item>
				{touched && error && <Text style={{ color: 'red' }}>{error}</Text>}
			</View>
		);
	}
}

class numberInput extends React.PureComponent {
	render() {
		const {
			input: { onChange, onBlur, ...restInput },
			style,
			label,
			currency = false,
			minus = false,
			labelType = 'inline',
			disabled = false,
			labelWidth = '25%',
			labelPress,
			type,
			icon,
			maxLength,
			maxValue,
			minValue,
			upDowns = false,
			meta: { touched, error, invalid, warning }
		} = this.props;
		const width = labelType == 'floating' || labelType == 'stacked' ? undefined : labelWidth;
		//val = typeof value === 'number' ? value.toString() : value;
		let { value } = this.props.input;
		//these will actually change the value!
		if (value == 'NaN') value = 0;
		if (typeof minValue == 'number' && value != '') value = Math.max(value, minValue).toString();
		if (typeof maxValue == 'number' && value != '') value = Math.min(value, maxValue).toString();
		if (value != this.props.input.value) onChange(value || '0');

		if (minus) value = minusOf(value, currency);

		return (
			<View style={[styles.innerContainer, { justifyContent: 'space-between' }, style]}>
				{!!icon && <Icon name={icon} style={styles.icon} />}
				{label && <Label style={[styles.inlineLabel, { width }]}>{label}</Label>}
				{labelPress && (
					<TouchableOpacity style={{ width: 10, marginRight: 10 }} onPress={labelPress}>
						<Icon name="help-circle" style={styles.helpCircle} />
					</TouchableOpacity>
				)}
				<Item accessible={false} style={{ justifyContent: 'flex-end' }} inlineLabel error={!!error} success={touched && !error && !invalid}>
					{upDowns && (
						<Button
							transparent
							style={{ width: 50 }}
							onPress={() => {
								onBlur((parseInt(value) + 1).toString());
							}}>
							<Icon name="arrow-up" />
						</Button>
					)}
					<Input
						ref="input"
						selectTextOnFocus
						keyboardType={'numeric'}
						disabled={disabled}
						maxLength={maxLength}
						style={{ width: upDowns ? 40 : undefined, minWidth: 0, flexGrow: 0, flexShrink: 0, flexBasis: 50, textAlign: upDowns ? 'center' : 'right' }}
						onChangeText={onChange}
						onEndEditing={onBlur}
						onBlur={isWeb ? onBlur : undefined}
						value={value}
						{...restInput}
					/>
					{upDowns && (
						<Button
							transparent
							style={{ width: 50 }}
							onPress={() => {
								//onChange((parseInt(value) - 1).toString());
								onBlur((parseInt(value) - 1).toString());
							}}>
							<Icon name="arrow-down" />
						</Button>
					)}
					{touched && !!value && !error && <Icon name="checkmark-circle" style={styles.checkMark} />}
					{error && <Icon name="close-circle" style={styles.errorMark} />}
				</Item>
				{touched && error && <Text style={{ color: 'red' }}>{error}</Text>}
			</View>
		);
	}
}

class moneyInput extends React.PureComponent {
	render() {
		const {
			input: { onChange, onBlur, value, ...restInput },
			label,
			style,
			placeholder,
			currency = false,
			minus = false,
			allowDecimals = true,
			labelType = 'fixed',
			labelWidth = '50%',
			labelPress,
			disabled = false,
			icon,
			type,
			meta: { touched, error, invalid, warning, active }
		} = this.props;
		const showInactiveZeros = allowDecimals && !!value && !value.includes('.') && !active;

		return (
			<View style={[styles.mainContainer, style]}>
				<View style={styles.innerContainer}>
					{!!icon && <Icon name={icon} style={styles.icon} />}
					{label && <Label style={[styles.inlineLabel, { width: labelWidth }]}>{label}</Label>}
					{labelPress && (
						<TouchableOpacity style={{ width: 10, marginRight: 10 }} onPress={labelPress}>
							<Icon name="help-circle" style={styles.helpCircle} />
						</TouchableOpacity>
					)}
					<Item accessible={false} style={{ flex: 1 }} fixedLabel error={!!error} success={touched && !error && !invalid} disabled={disabled}>
						<Input
							ref="input"
							underline={false}
							placeholder={placeholder}
							selectTextOnFocus
							disabled={disabled}
							keyboardType={isWeb ? 'number-pad' : 'decimal-pad'}
							style={{ textAlign: 'right', minWidth: 100, flex: 1, color: disabled ? '#AAA' : '#000' }}
							onChangeText={onChange}
							onEndEditing={onBlur}
							onBlur={isWeb ? onBlur : undefined}
							value={minus ? minusOf(value, currency) : value}
							{...restInput}
						/>
						{!!value && <Text style={{ textAlign: 'right', width: 10, position: 'relative', left: -19 - 9 * value.length, color: '#AAA' }}>£</Text>}
						{!allowDecimals && !!value && <Text style={{ width: 24, marginLeft: -57, marginRight: 33, paddingTop: 1, color: '#b3b3b3' }}>.00</Text>}
						{showInactiveZeros && <Text style={{ width: 24, marginLeft: -15, marginRight: 13, paddingTop: 1, color: '#b3b3b3' }}>.00</Text>}
						{touched && !!value && !error && <Icon name="checkmark-circle" style={styles.checkMark} />}
						{error && <Icon name="close-circle" style={styles.errorMark} />}
					</Item>
				</View>
				{touched && !!error && <Text style={{ color: redColour, textAlign: 'right' }}>{error}</Text>}
			</View>
		);
	}
}

class renderPicker extends React.PureComponent {
	render() {
		const {
			input: { onChange, value, ...inputProps },
			label,
			prompt,
			mode = 'dialog',
			style,
			pickerStyle,
			labelType = 'inline',
			labelWidth = '50%',
			children,
			disabled = false,
			icon,
			meta: { touched, error },
			emptyText,
			allowEmpty = false,
			...pickerProps
		} = this.props;

		const width = !!labelWidth ? labelWidth : undefined;
		const flex = !!labelWidth ? null : 0.7;

		//const borderColor=error?'red':undefined;
		//console.log(children, value);
		var kids = children.slice(0);
		if (!!emptyText && (!value || (!!value && allowEmpty))) kids.push(<Picker.Item key={'empty'} label={emptyText} value="0" style={{ color: '#AAA' }} />);

		return (
			<View style={[styles.mainContainer, style]}>
				<View style={[styles.innerContainer, { flexDirection: labelType == 'inline' ? 'row' : 'column' }]}>
					{icon && <Icon name={icon} style={styles.icon} />}
					{!!label && <Label style={[{ width, flex, flexDirection: 'row', color: '#2f6483' }, labelType == 'inline' ? { marginLeft: 5 } : { marginTop: 15 }]}>{label}</Label>}
					<Item accessible={false} style={{ flex: 1, borderWidth: 0, backgroundColor: 'transparent', width: '100%' }}>
						<Picker
							enabled={!disabled}
							prompt={!!prompt ? prompt : label}
							iosHeader={!!prompt ? prompt : label}
							style={[{ flex: 1, borderWidth: 0, backgroundColor: 'transparent', maxWidth: '100%' }, pickerStyle, labelType == 'inline' ? { paddingVertical: 10 } : { paddingBottom: 10 }]}
							ref="input"
							error={error}
							disabled={disabled}
							selectedValue={value || '0'}
							onValueChange={v => onChange(v)}
							{...inputProps}
							{...pickerProps}>
							{kids}
						</Picker>
					</Item>
					{!!touched && !!error ? <Icon name="close-circle" style={{ color: 'red', margin: 5 }} /> : undefined}
				</View>
				{!!touched && !!error && <Text style={{ color: 'red', alignSelf: 'center' }}>{error}</Text>}
			</View>
		);
	}
}

class displaySelection extends React.PureComponent {
	//like a picker but just displays. Needs items with id, (displayProperty)
	render() {
		const {
			input: { value, ...inputProps },
			label,
			prompt,
			style,
			labelType = 'inline',
			labelWidth = '50%',
			children,
			disabled = false,
			icon,
			meta: { touched, error },
			items,
			displayProperty,
			emptyText
		} = this.props;

		const width = !!labelWidth ? labelWidth : undefined;
		const flex = !!labelWidth ? null : 0.7;

		//console.log(this.props, emptyText);
		let text;
		if (!items) {
			text = '-';
		} else if (!value) {
			text = emptyText;
		} else {
			const selected = items.find(v => v.id == value);
			text = selected ? selected[displayProperty] : '?';
		}
		//console.log(text);

		return (
			<View style={[styles.innerContainer, { flexDirection: labelType == 'inline' ? 'row' : 'column' }, style]}>
				{icon && <Icon name={icon} style={styles.icon} />}
				<View style={{ flex: 1, borderBottomColor: '#d9d5dc', borderBottomWidth: 1 }}>
					{!!label && <Label style={{ width, flex, flexDirection: 'row', marginLeft: 5, marginVertical: labelType == 'inline' ? 15 : 5, color: '#2f6483' }}>{label}</Label>}
					<Label style={{ marginLeft: 8, marginVertical: 5, fontSize: 16 }}>{text}</Label>
				</View>
				{!!touched && !!error && (
					<View style={{ flexDirection: 'row' }}>
						<Icon name="close-circle" style={{ color: 'red', margin: 5, fontSize: 14 }} />
						<Text style={{ color: 'red' }}>{error}</Text>
					</View>
				)}
			</View>
		);
	}
}

class renderDateField extends React.PureComponent {
	render() {
		const {
			input: { onChange, onBlur, value, ...restInput },
			pickerStyle,
			placeholder = 'Select Date',
			label,
			style,
			disabled = false,
			labelWidth = '50%',
			labelType = 'inline',
			displayFormat = 'ddd DD/MM/YY',
			noIcon = false,
			labelPress,
			showIconWeb = false,
			meta: { touched, error, invalid },
			...custom
		} = this.props;
		const width = !!labelWidth ? labelWidth : undefined;
		const flex = !!labelWidth ? null : 0.7;
		const success = touched && !error && !invalid;
		const borderColor = success ? greenColour : error ? redColour : darkGrey;
		const isDate = value && ((typeof value == 'string' && value.split('-').length == 3) || (Object.prototype.toString.call(value) === '[object Date]' && !isNaN(value)));
		const pad = function (num) {
			return ('00' + num).slice(-2);
		};

		return (
			<View style={[styles.innerContainer, style]}>
				{!noIcon && <Icon name="calendar" style={styles.icon} />}
				{!!label && labelType == 'inline' && <Label style={[styles.inlineLabel, { flex, width }]}>{label}</Label>}
				{!!labelPress && (
					<TouchableOpacity style={{ width: 10, marginRight: 10 }} onPress={labelPress}>
						<Icon name="help-circle" style={styles.helpCircle} />
					</TouchableOpacity>
				)}
				<View style={{ flex: 1, alignItems: label ? 'flex-end' : 'flex-start' }}>
					<Item accessible={false} style={{ flex: 1, height: 45, borderWidth: 0, backgroundColor: 'transparent', maxWidth: 150 }}>
						{!!label && labelType != 'inline' && <Label style={{ flex, width, color: '#2f6483', marginLeft: 5 }}>{label}</Label>}
						{isWeb && !isDate ? (
							<Input
								ref="input"
								underline={false}
								placeholder="dd/mm/yyyy"
								placeholderTextColor="#AAA"
								selectTextOnFocus
								disabled={disabled}
								style={{ textAlign: 'right', maxWidth: 150 }}
								onBlur={e => {
									const v = e.target.value;
									if (!v || typeof v != 'string') return false;
									const sp = v.split('/');
									__DEV__ && console.log(sp);
									if (sp && sp.length == 3) onChange(new Date(`${sp[2]}-${sp[1]}-${sp[0]}`));
									onBlur();
								}}
							/>
						) : (
							<DatePicker
								date={value}
								style={{ flex: 1, minWidth: 150 }}
								mode="date"
								placeholder={placeholder}
								format="YYYY-MM-DD"
								displayFormat={displayFormat}
								confirmBtnText="Confirm"
								cancelBtnText="Cancel"
								disabled={disabled}
								showIcon={showIconWeb && isWeb}
								customStyles={
									pickerStyle || {
										dateIcon: {
											position: 'absolute',
											left: 0,
											top: 4,
											marginLeft: 0
										},
										dateInput: {
											paddingLeft: 5,
											borderColor: 'rgba(0, 0, 0, 0)'
										}
									}
								}
								onDateChange={v => onChange(v ? `${v.getFullYear()}-${pad(v.getMonth() + 1)}-${pad(v.getDate())}` : null)}
							/>
						)}
						{!!touched && !!error && <Text style={{ color: 'red' }}>{error}</Text>}
					</Item>
				</View>
			</View>
		);
	}
}

class renderCheckbox extends React.PureComponent {
	render() {
		const { input, label, custom, disabled, children, style } = this.props;

		return (
			<View style={[styles.mainContainer, { marginLeft: 2, marginTop: 5, marginBottom: 5, borderBottomWidth: 0 }, style]}>
				<View style={styles.innerContainer}>
					<Label style={[styles.inlineLabel, { flex: 1 }]}>{label}</Label>
					<View style={{ flex: 1, alignItems: 'center' }}>
						<Switch disabled={disabled} {...input} value={input.value ? true : false} onValueChange={() => input.onChange(!input.value)} />
					</View>
				</View>
				{children}
			</View>
		);
	}
}

class renderSwitch extends React.PureComponent {
	render() {
		const { input, label, labelPress, custom, disabled, onVal = 'Yes', offVal = 'No', icon, onNonBool = true, offNonBool = false, style, children } = this.props;

		return (
			<ListItem style={[styles.mainContainer, { paddingTop: 7, paddingBottom: 7, marginLeft: 2, borderBottomWidth: 0 }, style]}>
				<View style={styles.innerContainer}>
					<View style={{ flex: 1 }}>
						{!!icon && <Icon name={icon} size={14} style={{ fontSize: 18, alignSelf: 'center', color: '#2f6483' }} />}
						<Label style={[styles.inlineLabel]}>{label}</Label>
						{labelPress && (
							<TouchableOpacity style={{ width: 10, marginRight: 10 }} onPress={labelPress}>
								<Icon name="help-circle" style={styles.helpCircle} />
							</TouchableOpacity>
						)}
					</View>
					<View style={{ alignItems: 'center', flex: 1 }}>
						<Switch
							disabled={disabled}
							{...input}
							value={input.value == onNonBool ? true : false}
							onValueChange={() => input.onChange(input.value == offNonBool ? onNonBool : offNonBool)}
							style={{ width: 50 }}
						/>
						<Label style={{ color: '#2f6483' }}>{input.value == onNonBool ? onVal : offVal}</Label>
					</View>
				</View>
				{children}
			</ListItem>
		);
	}
}

class renderAutoComplete extends React.PureComponent {
	//validator checks this value is in the list. Value can then be updated to reduxform. But we will need to filter here
	//data is data to choose from.
	/*
		display and id properties expected

	*/
	constructor(props) {
		super(props);
		this.state = {
			query: '',
			hideResults: true,
			listHeight: 150,
			selectedItem: null
		};
	}

	doSearch(query) {
		const { data } = this.props;
		if (!query || query === '') {
			return data;
		}

		const regex = new RegExp(`${query.trim()}`, 'i');
		//this.props.input.onChange(query); //send to reduxform
		return data.filter(item => item.display.search(regex) >= 0);
	}

	fromId(id) {
		const { data } = this.props;
		__DEV__ && console.log('fromId', id);
		if (id === 0) return '';
		if (id != '' && isNaN(parseInt(id))) return id; //its a string!
		const find = data.filter(item => item.id == id);
		return find && find[0] && find[0].display;
	}

	renderItem({ index, item, separators }) {
		const {
			input: { onChange, value, ...restInput }
		} = this.props;
		//console.log('render', item);
		return (
			<TouchableOpacity pointerEvents="box-only" style={{ backgroundColor: this.state.selectedItem == index ? '#99F' : '#FFF', padding: 5 }} key={index} onPress={() => this.onSelect(item)}>
				<Text>{item.display}</Text>
			</TouchableOpacity>
		);
	}

	onSelect(item) {
		if (__DEV__) console.log('selected', item);
		this.setState({ query: false, hideResults: true });
		this.props.input.onChange(item.id);
	}

	onBlur(filteredData) {
		//what if we pressed on one?
		__DEV__ && console.log('onBlur');
		//if only one in list, select it
		if (filteredData && filteredData.length == 1) return this.onSelect(filteredData[0]);
		//if up/down selected one, use it
		if (this.state.selectedItem != null) this.onSelect(filteredData[this.state.selectedItem]);
		//if none in list, and more than 4 chars, make one!
		if (filteredData.length == 0 && this.state.query && this.state.query.length > 2) this.props.openAdder(this.state.query); //this.props.input.onChange(this.state.query);
		setTimeout(() => this.setState({ query: false, hideResults: true }), 500);
	}
	handleKey(key, filteredData) {
		//console.log(key);
		if (key == 'ArrowDown' && filteredData.length)
			this.setState({ hideResults: false, selectedItem: this.state.selectedItem == null ? 0 : Math.min(filteredData.length - 1, this.state.selectedItem + 1) });
		if (key == 'ArrowUp' && this.state.selectedItem != null) this.setState({ selectedItem: Math.max(0, this.state.selectedItem - 1) });
		if (key == 'Backspace' && this.props.input.value) this.props.input.onChange(null);
	}

	//todo: How to delete???

	render() {
		const {
			input: { onChange, value, ...restInput },
			disabled,
			pickerStyle,
			data,
			textChanged,
			renderItem,
			emptyText,
			icon,
			meta: { touched, error },
			openAdder, //opens adding dialog with the name given
			style,
			label,
			labelWidth = '25%',
			...custom
		} = this.props;
		const { query, hideResults } = this.state;
		const filteredData = this.doSearch(query);
		//__DEV__ && console.log(this.state.listHeight, value, query, filteredData, hideResults);

		return (
			<>
				<View
					style={[{ flexDirection: 'row', zIndex: 1, width: '100%', alignItems: 'center' }, style]}
					onLayout={event => {
						const layout = event.nativeEvent.layout;
						const windowHeight = Dimensions.get('window').height;
						const listHeight = Math.max(200, windowHeight - (layout.y + layout.height) - 100);
						__DEV__ && console.log('list height: ', listHeight, 'window', Dimensions.get('window').height, 'y', layout.y, 'h', layout.height);
						if (listHeight != this.state.listHeight) this.setState({ listHeight });
					}}>
					{icon && <Icon name={icon} style={[styles.icon, { alignSelf: 'center' }]} />}
					{label && <Label style={[styles.inlineLabel, { width: labelWidth }]}>{label}</Label>}
					<Item accessible={false} style={{ flex: 1, zIndex: 1 }} error={!!error}>
						{!hideResults && (
							<FlatList
								style={{
									zIndex: 1,
									maxHeight: this.state.listHeight,
									position: 'absolute',
									top: 37,
									width: '100%',
									backgroundColor: '#BCF',
									borderColor: '#333',
									borderWidth: 1,
									shadowColor: '#AAA',
									shadowRadius: 8
								}}
								data={filteredData}
								renderItem={t => this.renderItem(t)}
								keyExtractor={item => item.id}
							/>
						)}
						{false && value != '' && isNaN(parseInt(value)) && (
							<Button
								transparent
								onPress={() => {
									this.setState({ query: null });
									openAdder(value);
								}}>
								<Icon name="person-add" />
							</Button>
						)}
						<Input
							ref="input"
							placeholder={emptyText}
							returnKeyType="search"
							onKeyPress={event => this.handleKey(event.key, filteredData)}
							selectTextOnFocus={true}
							value={query ? query : value ? this.fromId(value) : ''}
							onChangeText={text => this.setState({ query: text, hideResults: false, selectedItem: null })}
							onEndEditing={() => this.onBlur(filteredData)}
							onBlur={isWeb ? () => this.onBlur(filteredData) : undefined}
							placeholderTextColor="#AAA"
						/>
						{data.length > 0 && (
							<Button small transparent style={{ position: 'absolute', right: 0, alignSelf: 'center' }} onPress={() => this.setState({ hideResults: !hideResults, query: false })}>
								<Icon name="arrow-dropdown" />
							</Button>
						)}
						{touched && error && <Icon name="close-circle" style={styles.errorMark} />}
					</Item>
				</View>
				{touched && error && <Text style={{ color: redColour }}>{error}</Text>}
			</>
		);
	}
}

class renderTypeAhead extends React.PureComponent {
	//this is so similar to above it should be merged

	constructor(props) {
		super(props);
		this.state = {
			query: '',
			hideResults: true,
			listHeight: 150,
			selectedItem: null
		};
	}

	componentDidMount() {
		if (this.props.autoFocus)
			InteractionManager.runAfterInteractions(() => {
				this.inputRef._root.focus();
			});
	}

	doSearch(query) {
		const { data } = this.props;
		if (!query || query === '') {
			return data;
		}

		const regex = new RegExp(`${query.trim()}`, 'i');
		//this.props.input.onChange(query); //send to reduxform
		return data.filter(item => item.ref.search(regex) >= 0);
	}

	fromId(id) {
		const { data } = this.props;
		__DEV__ && console.log('fromId', id);
		if (id === 0) return '';
		if (id != '' && isNaN(parseInt(id))) return id; //its a string!
		const find = data.filter(item => item.id == id);
		return find && find[0] && find[0].display;
	}

	renderItem({ index, item, separators }) {
		const {
			input: { onChange, value, ...restInput }
		} = this.props;
		//console.log('render', item);
		return (
			<TouchableOpacity pointerEvents="box-only" style={{ backgroundColor: this.state.selectedItem == index ? '#99F' : '#FFF', padding: 5 }} key={index} onPress={() => this.onSelect(item)}>
				<Text>{item.ref}</Text>

				{!!item.unit && (
					<Text style={{ position: 'absolute', top: 5, right: 5, fontSize: 12 }}>
						£{item.unit}
						{!!item.unitname && ` / ${item.unitname}`}
					</Text>
				)}
				{!!item.description && <Text note>{item.description}</Text>}
			</TouchableOpacity>
		);
	}

	onSelect(item) {
		if (__DEV__) console.log('selected', item);
		this.setState({ query: false, hideResults: true });
		this.props.input.onChange(item.ref);
		this.props.onSelectCurrent(item);
	}

	onBlur(filteredData) {
		//what if we pressed on one?
		__DEV__ && console.log('onBlur');

		//if up/down selected one, use it
		if (this.state.selectedItem != null) this.onSelect(filteredData[this.state.selectedItem]);
		//if none in list...
		if (filteredData.length == 0 && this.state.query) this.props.input.onChange(this.state.query);
		setTimeout(() => this.setState({ query: false, hideResults: true }), 500);
	}
	handleKey(key, filteredData) {
		//console.log(key);
		if (key == 'ArrowDown' && filteredData.length)
			this.setState({ hideResults: false, selectedItem: this.state.selectedItem == null ? 0 : Math.min(filteredData.length - 1, this.state.selectedItem + 1) });
		if (key == 'ArrowUp' && this.state.selectedItem != null) this.setState({ selectedItem: Math.max(0, this.state.selectedItem - 1) });
		if (key == 'Backspace' && this.props.input.value) this.props.input.onChange(null);
	}

	//todo: How to delete???

	render() {
		const {
			input: { onChange, value, ...restInput },
			disabled,
			pickerStyle,
			data,
			textChanged,
			renderItem,
			emptyText,
			icon,
			meta: { touched, error },
			openAdder, //opens adding dialog with the name given
			style,
			label,
			labelWidth = '25%',
			autoFocus = false,
			...custom
		} = this.props;
		const { query, hideResults } = this.state;
		const filteredData = this.doSearch(query);
		//__DEV__ && console.log(this.state.listHeight, value, query, filteredData, hideResults);
		//__DEV__ && console.log(filteredData);

		return (
			<>
				<View
					style={[{ flexDirection: 'row', zIndex: 1, width: '100%', alignItems: 'center' }, style]}
					onLayout={event => {
						const layout = event.nativeEvent.layout;
						const windowHeight = Dimensions.get('window').height;
						const listHeight = Math.max(200, windowHeight - (layout.y + layout.height) - 100);
						__DEV__ && console.log('list height: ', listHeight, 'window', Dimensions.get('window').height, 'y', layout.y, 'h', layout.height);
						if (listHeight != this.state.listHeight) this.setState({ listHeight });
					}}>
					{icon && <Icon name={icon} style={[styles.icon, { alignSelf: 'center' }]} />}
					{label && <Label style={[styles.inlineLabel, { width: labelWidth }]}>{label}</Label>}
					<Item accessible={false} style={{ flex: 1, zIndex: 1 }} error={!!error}>
						{!hideResults && (
							<FlatList
								style={{
									zIndex: 1,
									maxHeight: this.state.listHeight,
									position: 'absolute',
									top: 37,
									width: '100%',
									backgroundColor: '#BCF',
									borderColor: '#333',
									borderWidth: 1,
									shadowColor: '#AAA',
									shadowRadius: 8
								}}
								data={filteredData}
								renderItem={t => this.renderItem(t)}
								keyExtractor={item => item.id}
							/>
						)}
						{false && value != '' && isNaN(parseInt(value)) && (
							<Button
								transparent
								onPress={() => {
									this.setState({ query: null });
									openAdder(value);
								}}>
								<Icon name="person-add" />
							</Button>
						)}
						<Input
							ref={r => (this.inputRef = r)}
							placeholder={emptyText}
							returnKeyType="search"
							onKeyPress={event => this.handleKey(event.key, filteredData)}
							selectTextOnFocus={true}
							value={query ? query : value ? this.fromId(value) : ''}
							onChangeText={text => this.setState({ query: text, hideResults: false, selectedItem: null })}
							onEndEditing={() => this.onBlur(filteredData)}
							onBlur={isWeb ? () => this.onBlur(filteredData) : undefined}
							placeholderTextColor="#AAA"
							autoFocus={autoFocus}
						/>
						{data.length > 0 && (
							<Button small transparent style={{ position: 'absolute', right: 0, alignSelf: 'center' }} onPress={() => this.setState({ hideResults: !hideResults, query: false })}>
								<Icon name="arrow-dropdown" />
							</Button>
						)}
						{touched && error && <Icon name="close-circle" style={styles.errorMark} />}
					</Item>
				</View>
				{touched && error && <Text style={{ color: redColour }}>{error}</Text>}
			</>
		);
	}
}

class renderSlider extends React.PureComponent {
	render() {
		const {
			input: { onChange, value, ...restInput },
			label,
			custom,
			disabled,
			labelType = 'inline',
			max = 100,
			showPerc = true,
			step = 5,
			style,
			meta: { touched, error, invalid, warning }
		} = this.props;

		return (
			<View style={[styles.mainContainer, style]}>
				<View style={[styles.innerContainer, { flexDirection: labelType == 'inline' ? 'row' : 'column' }]}>
					<Label style={[styles.inlineLabel, { flex: 1 }]}>{label}</Label>
					<Item accessible={false} style={[{ flex: 1, marginLeft: 2, paddingTop: 5, paddingBottom: 5 }, style]} error={!!error}>
						<View style={{ flex: 1, flexDirection: 'row' }}>
							<Slider style={{ flex: 1, paddingRight: 50, height: 20 }} disabled={disabled} {...restInput} maximumValue={max} value={Number(value)} step={step} onValueChange={onChange} />
							{!!showPerc && <Text style={{ width: 50 }}>{value}%</Text>}
						</View>
					</Item>
					{!!touched && !!error && <Text style={{ color: 'red' }}>{error}</Text>}
				</View>
			</View>
		);
	}
}

const styles = StyleSheet.create({
	mainContainer: {
		// includes children
		width: '100%',
		minHeight: 45,
		flex: 1,
		flexDirection: 'column'
	},
	innerContainer: {
		// excludes children
		width: '100%',
		flex: 1,
		minHeight: 45,
		flexDirection: 'row',
		alignItems: 'center'
	},
	icon: {
		marginLeft: 5,
		width: 20,
		color: '#2f6483',
		fontSize: 18
	},
	helpCircle: {
		fontSize: 20,
		width: 20,
		marginLeft: 5,
		color: '#4499b9'
	},
	inlineLabel: {
		flexDirection: 'row',
		marginLeft: 5,
		paddingTop: 1,
		paddingRight: 5,
		color: '#2f6483'
	},
	label: {
		color: '#2f6483'
	},
	checkMark: {
		position: 'absolute',
		right: 0,
		fontSize: 15,
		paddingRight: 0,
		color: greenColour,
		alignSelf: 'center',
		marginTop: 0
	},
	errorMark: {
		position: 'absolute',
		right: 0,
		fontSize: 15,
		paddingRight: 0,
		color: redColour,
		alignSelf: 'center',
		marginTop: 0
	}
});

export {
	textInput,
	moneyInput,
	renderPicker,
	renderDateField,
	renderCheckbox,
	percentInput,
	renderSwitch,
	numberInput,
	renderAutoComplete,
	displayInput,
	picInput,
	renderSlider,
	displaySelection,
	renderTypeAhead
};
